import React, { ChangeEvent } from 'react';
import { Form, Formik } from 'formik';
import { mixed, object, string } from 'yup';
import { Button, FormControl, FormControlLabel, Grid, Paper, Radio, RadioGroup, Typography } from '@mui/material';
import { ERROR_MAIL } from '../../../../utils/constants.utils';
import { Link } from 'react-router-dom';
import './moving-in-step-three.ui.scss';
import { ReferenceDto } from '../../../../services/dtos/reference.dto';
import AddressForm from '../../../forms/moving-in/moving-in-step-three/address.form';
import ContactDetailsForm from '../../../forms/moving-in/moving-in-step-three/contact-details.form';
import { PageContentDto } from '../../../../services/dtos/page-content.dto';
import { MovingInFinishDto } from '../../../../services/dtos/moving-in-finish.dto';
import { verifyAge } from '../../../../utils/form-validators.utils';
import { UserDto } from '../../../../services/dtos/user.dto';
import { getValueOrEmpty } from '../../../../utils/traitment.utils';

/**
 * Formualire global avec toutes les règles et valeurs par defauts
 * @param props
 * @constructor
 */
export default function MovingInStepThreeUi(props: {
    user?: UserDto;
    pageContent: PageContentDto;
    loading: boolean;
    //handle lors du changement de pays
    handleChangeCountry: (e: React.SyntheticEvent, v: ReferenceDto | null) => void;
    //handle lors du changement de pays entrant
    handleChangeCountryIncomingPerson: (e: React.SyntheticEvent, v: ReferenceDto | null) => void;
    //handle lors du submit
    handleSumbitForm: (values: any) => void;
    //List des pays
    countriesSelection: ReferenceDto[];
    //handle lors du changement de valeur connait entrant
    handleChangeIncomingPerson: (e: ChangeEvent<HTMLInputElement>, value: string) => void;
    //valeur connait entrant
    incomingPerson: string;
    //valeur si personne moral
    isMoral: boolean;
    //handle lors du changement de valeur d'interlocuteur
    handleChangeInterlocutor: (interlocutor: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
    //liste des interlocuteurs
    interlocutorsSelection: { value: string; label: string }[];
    //liste des civilités
    civilities: ReferenceDto[];
    //validate
    validate: boolean;
    //Identifiant du contrat
    contractId?: string;
    //Pays sélectionné
    selectedCountry?: ReferenceDto;

    infosMovingInDto?: MovingInFinishDto;
}) {
    //Constantes
    const messageCaracteresMin = "Merci d'entrer deux caractères minimum";
    const nbCaracteresMin = 2;
    const nbCaracteresTel = 9;
    const chaine1 = 1;
    const chaineEnd = 10;
    const chaine0 = 0;
    const type = props.user?.type ? props.user?.type.at(-1) : '';
    const civilite = props.user?.civilite ? props.user?.civilite.at(-1) : '';
    // Schéma de validation des données
    const validationSchema = object({
        //Validartion du type d'entrant
        //Conditionné incomingPerson
        type: mixed<ReferenceDto>().required("Le type d'interlocuteur est obligatoire"),
        //Validation de la civilité
        //Conditionné incomingPerson
        civilite: mixed<ReferenceDto>().when(() =>
            props.isMoral
                ? mixed<ReferenceDto>().notRequired()
                : mixed<ReferenceDto>().required('La civilité est obligatoire')
        ),
        //Validation du nom
        //Conditionné incomingPerson
        nomUsage: string().when(() =>
            props.isMoral
                ? string().notRequired()
                : string()
                      .trim()
                      .required('Le nom est obligatoire')
                      .matches(
                          /^[A-Za-z-áàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ ]+$/,
                          "Seul les caractères alphabétiques, le tiret (-) et l'apostrophe (') sont autorisés"
                      )
                      .min(nbCaracteresMin, messageCaracteresMin)
        ),
        //Validation du prénom
        //Conditionné incomingPerson
        prenom: string().when(() =>
            props.isMoral
                ? string().notRequired()
                : string()
                      .trim()
                      .matches(
                          /^[A-Za-z-áàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ ]+$/,
                          "Seul les caractères alphabétiques, le tiret - et l'apostrophe ' sont autorisés"
                      )
                      .min(nbCaracteresMin, messageCaracteresMin)
                      .required('Le prénom est obligatoire')
        ),
        //Controle date de naissance
        dateNaissance: string().when(() =>
            props.isMoral
                ? string().notRequired()
                : string()
                      .required('La date de naissance est obligatoire')
                      .test('age', 'Vous devez avoir au moins 16 ans pour créer un compte', value => verifyAge(value))
        ),
        // Controle du siret
        siret: string().when(() =>
            !props.isMoral ? string().notRequired() : string().trim().required('Le numéro de SIRET est obligatoire')
        ),
        // Controle du salarié
        salaries: string().when(() =>
            !props.isMoral
                ? string().notRequired()
                : string().trim().required('Le nombre de salarié').matches(/^\d+$/, {
                      message: 'Seuls les caractères numériques sont autorisés',
                  })
        ),
        // Controle de la raison sociale
        raisonSociale: string().when(() =>
            !props.isMoral ? string().notRequired() : string().trim().required('La raison sociale est obligatoire')
        ),
        //Controle du champ tel portable
        //Controle :  taille / format
        telPort: string()
            .matches(/^\d+$/, {
                message: 'Caractère non valide inséré.',
            })
            .length(nbCaracteresTel, "Merci d'entrer 9 caractères."),
        //Controle du champ tel fixe
        //Controle :  taille / format
        telFixe: string()
            .matches(/^\d+$/, {
                message: 'Caractère non valide inséré.',
            })
            .length(nbCaracteresTel, "Merci d'entrer 9 caractères."),
        //Controle du champ mail
        //Controle : taille / format
        mail: string()
            .trim()
            .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, ERROR_MAIL)
            .required(),
        //Validation relevé de compteur
        numeroRue: string().trim().required('Veuillez renseigner votre numéro de rue'),
        //Validation de l'adresse
        rue: string().trim().required('Veuillez renseigner votre nom de rue'),
        ville: string().trim().required('Veuillez renseigner votre ville de résidence'),
        pays: mixed<ReferenceDto>().required('Veuillez choisir un pays'),
        codePostal: string().trim().required('Veuillez renseigner votre code postal').matches(/^\d+$/, {
            message: 'Seul les caractères numériques sont autorisés',
        }),
        // Validation du champ boite postale (optionnel)
        boitePostale: string().trim().notRequired(),
        // Validation des champs de complément
        complement: object().shape({
            batiment: string().trim().notRequired(),
            etage: string().trim().notRequired(),
            appartement: string().trim().notRequired(),
            escalier: string().trim().notRequired(),
            ville: string().trim().notRequired(),
            numeroRue: string().trim().notRequired(),
            rue: string().trim().notRequired(),
        }),
        //Validation des champs de l'entrant
        sortantInfos: object().shape({
            //Validation du champ numero rue
            numeroRue: string()
                .trim()
                .when(() =>
                    props.incomingPerson === 'Non'
                        ? string().notRequired()
                        : string().required('Veuillez renseigner le numéro de rue')
                ),
            //Validation du champ rue
            rue: string()
                .trim()
                .when(() =>
                    props.incomingPerson === 'Non'
                        ? string().notRequired()
                        : string().required('Veuillez renseigner le nom de rue')
                ),
            //Validation du champ ville
            ville: string()
                .trim()
                .when(() =>
                    props.incomingPerson === 'Non'
                        ? string().notRequired()
                        : string().required('Veuillez renseigner la ville de résidence')
                ),
            //Validation du champ pays
            pays: mixed<ReferenceDto>().when(() =>
                props.incomingPerson === 'Non'
                    ? mixed<ReferenceDto>().notRequired()
                    : mixed<ReferenceDto>().required('Veuillez choisir un pays')
            ),
            //Validation du champ CP
            codePostal: string()
                .trim()
                .when(() =>
                    props.incomingPerson === 'Non'
                        ? string().notRequired()
                        : string().trim().required('Veuillez renseigner le code postal').matches(/^\d+$/, {
                              message: 'Seul les caractères numériques sont autorisés',
                          })
                ),
            // Validation du champ boite postale pour sortant (optionnel)
            boitePostale: string().trim().notRequired(),
            // Validation des champs de complément pour sortant
            complement: object().shape({
                batiment: string().trim().notRequired(),
                etage: string().trim().notRequired(),
                appartement: string().trim().notRequired(),
                escalier: string().trim().notRequired(),
                ville: string().trim().notRequired(),
                numeroRue: string().trim().notRequired(),
                rue: string().trim().notRequired(),
            }),
        }),
    });

    const iniValues = {
        type: type,
        civilite: civilite,
        nomUsage: '1' === type && props.user?.nomUsage ? props.user?.nomUsage : '',
        prenom: getValueOrEmpty(props.user?.prenom),
        dateNaissance: props.user?.dateNaissance ? props.user?.dateNaissance.substring(chaine0, chaineEnd) : '',
        siret: '',
        salaries: '',
        raisonSociale: '1' !== type && props.user?.nomUsage ? props.user?.nomUsage : '',
        telPort: props.user?.telPort ? props.user?.telPort.substring(chaine1, chaineEnd) : '',
        telFixe: props.user?.telFixe ? props.user?.telFixe.substring(chaine1, chaineEnd) : '',
        mail: getValueOrEmpty(props.user?.mailPerso),
        // Adresse standardisée
        address: '',
        numeroRue: props.infosMovingInDto?.address?.numeroRue ? props.infosMovingInDto?.address?.numeroRue : '',
        rue: props.infosMovingInDto?.address?.rue ? props.infosMovingInDto?.address?.rue : '',
        codePostal: props.infosMovingInDto?.address?.codePostal ? props.infosMovingInDto?.address?.codePostal : '',
        ville: props.infosMovingInDto?.address?.ville ? props.infosMovingInDto?.address?.ville : '',
        boitePostale: '',
        pays: { value: 'France', label: 'France' },
        complement: {
            batiment: props.infosMovingInDto?.address?.complement?.batiment || '',
            etage: props.infosMovingInDto?.address?.complement?.etage || '',
            appartement: props.infosMovingInDto?.address?.complement?.appartement || '',
            escalier: props.infosMovingInDto?.address?.complement?.escalier || '',
            ville: props.infosMovingInDto?.address?.complement?.ville || '',
            numeroRue: props.infosMovingInDto?.address?.complement?.numeroRue || '',
            rue: props.infosMovingInDto?.address?.complement?.rue || '',
        },
        sortantInfos: {
            address: '',
            numeroRue: '',
            rue: '',
            codePostal: '',
            ville: '',
            boitePostale: '',
            pays: { value: 'France', label: 'France' },
            complement: {
                batiment: '',
                etage: '',
                appartement: '',
                escalier: '',
                ville: '',
                numeroRue: '',
                rue: '',
            },
        },
    };
    //Retourne les deux composants
    //Premier composant possède les informations de la personne courante
    //Second composant possède les informations de la personne entrant si connu
    return (
        <Formik
            enableReinitialize={true}
            initialValues={iniValues}
            onSubmit={props.handleSumbitForm}
            validationSchema={validationSchema}
        >
            <Form>
                <Typography variant="h4">{props.pageContent.title}</Typography>
                <Typography variant="body1" sx={{ marginBottom: '10px' }}>
                    {props.pageContent.content}
                </Typography>
                <Grid container spacing={2} className="moving-in-step-4-infos">
                    {/*coordonnées de l'utilisateur*/}
                    <Grid item xs={12}>
                        <Paper>
                            {/*Connait l'entrant*/}
                            {/*si oui on affiche les infos*/}
                            {/*si non on n'affiche rien de plus*/}
                            <Typography variant="h5">Vos coordonnées</Typography>

                            <ContactDetailsForm
                                civilities={props.civilities}
                                isMoral={props.isMoral}
                                validate={props.validate}
                                handleChangeInterlocutor={props.handleChangeInterlocutor}
                                interlocutorsSelection={props.interlocutorsSelection}
                            />
                        </Paper>
                    </Grid>
                    {/*vue adresse de correspondance de la personne entrante*/}
                    <Grid item xs={12}>
                        <Paper>
                            {/*Connait l'entrant*/}
                            {/*si oui on affiche les infos*/}
                            {/*si non on n'affiche rien de plus*/}
                            <Typography variant="h5">Votre adresse de correspondance</Typography>

                            <AddressForm
                                countriesSelection={props.countriesSelection}
                                handleChangeCountry={props.handleChangeCountry}
                                selectedCountry={props.selectedCountry || { value: 'France', label: 'France' }}
                                name={''}
                            />
                        </Paper>
                    </Grid>
                    {/*vue informations de la personne sortante*/}
                    <Grid item xs={12}>
                        <Paper>
                            {/*Connait l'entrant*/}
                            {/*si oui on affiche les infos*/}
                            {/*si non on n'affiche rien de plus*/}
                            <Typography variant="h5">Connaisez-vous l'adresse de l'usager sortant ?</Typography>
                            <FormControl>
                                <RadioGroup
                                    row
                                    aria-labelledby="radio-buttons-group"
                                    name="radio-buttons-group"
                                    value={props.incomingPerson}
                                    onChange={props.handleChangeIncomingPerson}
                                >
                                    <FormControlLabel value={'Oui'} control={<Radio />} label="Oui" />
                                    <FormControlLabel value={'Non'} control={<Radio />} label="Non" />
                                </RadioGroup>
                            </FormControl>

                            {/*Infos de la personne*/}
                            {props.incomingPerson === 'Oui' ? (
                                <AddressForm
                                    countriesSelection={props.countriesSelection}
                                    handleChangeCountry={props.handleChangeCountryIncomingPerson}
                                    selectedCountry={{ value: 'France', label: 'France' }}
                                    name={'sortantInfos.'}
                                />
                            ) : (
                                ''
                            )}
                        </Paper>
                    </Grid>

                    {/*Emplacement des boutons annuler et envoyer*/}
                    <Grid item xs={0} sm={9}></Grid>
                    <Grid item xs={12} sm={3} className={'buttonsForm'}>
                        <Typography variant={'button'}>
                            {/*Redirection du la page contrat*/}
                            <Button variant="neutral" component={Link} to={'/j-emmenage/etape-deux'}>
                                Annuler
                            </Button>
                        </Typography>
                        {/*Envoi du formulaire*/}
                        <Typography variant={'button'}>
                            <Button type="submit" variant="contained" disabled={!props.validate}>
                                Envoyer
                            </Button>
                        </Typography>
                    </Grid>
                </Grid>
            </Form>
        </Formik>
    );
}
